import axios from 'axios';

export const http = axios.create({
  baseURL: process.env.VUE_APP_AXIOS_BASE_URL,
  method: process.env.VUE_APP_AXIOS_BASE_METHOD,
  timeout: 10000,
  timeoutErrorMessage: 'Não foi possível acessar o servidor neste momento, tente novamente mais tarde.',
  responseType: 'json',
  validateStatus: (status: number) => {
    return status >= 200 && status <= 300;
  },
  maxRedirects: 0,
});
